/**
 * Represents an action from the state content tab.
 */
export class ContentActionViewModel {
    static $inject = ['init'];
    constructor(init) {
        Object.assign(this, init);
    }
}
